import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MonthlyInvoiceRoutingModule } from './monthly-invoice-routing.module';
import { MonthlyInvoiceComponent } from './monthly-invoice.component';
import { NiceSelectModule } from 'ng-nice-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [MonthlyInvoiceComponent],
  imports: [
    CommonModule,
    MonthlyInvoiceRoutingModule,
    NiceSelectModule,
    NgxPaginationModule,
    FormsModule   
  ]
})
export class MonthlyInvoiceModule { }
